"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Abstract release converter.
 *
 * @author Radek Beran
 */


var AbstractReleaseConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AbstractReleaseConverter, _DataObjectConverter_);

  function AbstractReleaseConverter() {
    _classCallCheck(this, AbstractReleaseConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseConverter).apply(this, arguments));
  }

  return AbstractReleaseConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AbstractReleaseConverter = AbstractReleaseConverter;